/**
 * i18n (SPEC-11 §1): all UI strings go through t('key') with en.json as the only
 * locale in P0; the Setup language selector lists English only.
 */
import en from '../strings/en.json';

const BUNDLES: Record<string, Record<string, string>> = { en: en as Record<string, string> };

let locale = 'en';

export function t(key: string): string {
  const bundle = BUNDLES[locale] ?? (en as Record<string, string>);
  return bundle[key] ?? key;
}

export function setLocale(code: string): void {
  if (BUNDLES[code]) locale = code;
}

export function availableLocales(): Array<{ code: string; label: string }> {
  return [{ code: 'en', label: 'English' }];
}

/** Apply translations to any element with data-i18n attributes. */
export function translateDom(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-i18n]').forEach((el) => {
    const key = el.dataset['i18n'];
    if (key) el.textContent = t(key);
  });
}
